<script lang="ts">
  import { getRhythmHTML } from './rhythmSpan';

  export let timeSignatures: string[] = [];
  export let rhythmString: string = '';
  export let color: string = '#000';
  export let stroke: string | null = null;

  $: rhythmHTML = getRhythmHTML({
    rhythmString,
    timeSignatures,
    color,
    stroke,
  });
</script>

<span style="color: {color};">
  {@html rhythmHTML}
</span>
